export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10360.efa7438b.jpg";